import Client from '../axios-client';

const resource = '/wallet/wallets';

export default {
  payIn(walletId, payload) {
    return Client.put(`${resource}/${walletId}/pay-in`, payload);
  },
  payOut(walletId, payload) {
    return Client.put(`${resource}/${walletId}/pay-out`, payload);
  },
  correctOperation(walletId, operationId, payload) {
    return Client.put(`${resource}/${walletId}/operations/${operationId}/correction`, payload);
  },
  getWalletByOwner(ownerId) {
    return Client.get(`${resource}/owner/` + ownerId);
  },
  getWalletOperationsForGrid(walletId, parameters) {
    return Client.get(`${resource}/${walletId}/operations` + parameters);
  },
  getWalletOperationsForExcel: function(walletId, parameters) {
    return Client.get(`${resource}/${walletId}/operations/excel` + parameters,
      {
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      }
    )
  },
};
